<!-- <script src="https://js.stripe.com/v3/" async></script> -->
<div [formGroup]="form" class="form-typography">
  <div [formGroupName]="question.key">
    <div [formGroupName]="option.service">

      <div class="stripe-field margin-bottom-small">
        <div class="stripePayment"></div>
      </div>

      <div *ngIf="raptorPaymentService.displayError && raptorPaymentService.stripeErrors.cardFailure" class="open-form-info padding-medium margin-bottom-medium">
        <h4 class="margin-bottom-xsmall">We&rsquo;re sorry, but we had trouble processing your new card.</h4>
        <p *ngIf="question.settings?.cta">Please check your card details and try again. If the problem continues, please <a [href]="[question.settings.cta.support_url]">{{ question.settings.cta.support_label }}</a>.</p>
      </div>

    </div>
  </div>
</div>

<section *ngIf="!environment.production" class="margin-top-medium">
  <h4 (click)="test = !test" class="margin-bottom-xsmall">{{ test ? 'Hide test card numbers &#8613;' : 'Show test card numbers &#8615;' }}</h4>

  <div *ngIf="test">
    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000360000006</div>
      <div class="cell cell-large-col-span-8">Australian Test Card - Charges AUD</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000005540000008</div>
      <div class="cell cell-large-col-span-8">New Zealand Test Card - Charges NZD</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4242424242424242</div>
      <div class="cell cell-large-col-span-8">US Visa</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">5555555555554444</div>
      <div class="cell cell-large-col-span-8">US Mastercard</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000005126</div>
      <div class="cell cell-large-col-span-8">Charge succeeds but refunding a captured charge fails asynchronously with a failure_reason of expired_or_canceled_card. Note that because refund failures are asynchronous, the refund will appear to be successful at first and will only have the failed status on subsequent fetches. We also notify you of refund failures using the charge.refund.updated webhook event.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000000101</div>
      <div class="cell cell-large-col-span-8">If a CVC number is provided, the cvc_check fails. If your account is blocking payments that fail CVC code validation, the charge is declined.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000000341</div>
      <div class="cell cell-large-col-span-8">Attaching this card to a Customer object succeeds, but attempts to charge the customer fail.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000009235</div>
      <div class="cell cell-large-col-span-8">Results in a charge with a risk_level of elevated.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000004954</div>
      <div class="cell cell-large-col-span-8">Results in a charge with a risk_level of highest.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4100000000000019</div>
      <div class="cell cell-large-col-span-8">Results in a charge with a risk_level of highest. The charge is blocked as it's considered fraudulent.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000000002</div>
      <div class="cell cell-large-col-span-8">Charge is declined with a card_declined code.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000009995</div>
      <div class="cell cell-large-col-span-8">Charge is declined with a card_declined code. The decline_code attribute is insufficient_funds.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000009987</div>
      <div class="cell cell-large-col-span-8">Charge is declined with a card_declined code. The decline_code attribute is lost_card.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000009979</div>
      <div class="cell cell-large-col-span-8">Charge is declined with a card_declined code. The decline_code attribute is stolen_card.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000000069</div>
      <div class="cell cell-large-col-span-8">Charge is declined with an expired_card code.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000000127</div>
      <div class="cell cell-large-col-span-8">Charge is declined with an incorrect_cvc code.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4000000000000119</div>
      <div class="cell cell-large-col-span-8">Charge is declined with a processing_error code.</div>
    </div>

    <div class="grid margin-bottom-xxsmall">
      <div class="cell cell-large-col-span-4">4242424242424241</div>
      <div class="cell cell-large-col-span-8">Charge is declined with an incorrect_number code as the card number fails the Luhn check.</div>
    </div>

  </div>
</section>
